import React from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";

const CareersDetailsForm = ({
  decodeTitle,
  handleSubmit,
  handleChange,
  formValues,
  errors,
}) => {
  return (
    <div className="bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="flex justify-end mb-6">
        <Link
          to="/careers"
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition"
        >
          <svg
            className="w-4 h-4 mr-2"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </Link>
      </div>

      <h1 className="text-4xl font-extrabold text-gray-900 mb-4 text-center">
        Apply for:{" "}
        <span className="text-blue-600 capitalize">{decodeTitle}</span>
      </h1>
      <p className="text-lg text-gray-600 text-center mb-10">
        Please fill in your details and upload your resume.
      </p>

      <form
        onSubmit={handleSubmit}
        className="max-w-3xl mx-auto bg-white/80 backdrop-blur-md ring-1 ring-gray-200 rounded-2xl p-10 shadow-xl space-y-8"
      >
        {/* Name */}
        <div>
          <label className="block text-gray-700 mb-2 text-sm font-semibold">
            Full Name
          </label>
          <input
            type="text"
            name="name"
            value={formValues.name}
            onChange={handleChange}
            className={`w-full border ${
              errors.name ? "border-red-500" : "border-gray-300"
            } rounded-lg px-5 py-3 text-base focus:ring-2 focus:ring-blue-500 focus:outline-none`}
            placeholder="Enter your name"
          />
          {errors.name && (
            <p className="text-sm text-red-500 mt-1">{errors.name}</p>
          )}
        </div>

        {/* Email */}
        <div>
          <label className="block text-gray-700 mb-2 text-sm font-semibold">
            Email Address
          </label>
          <input
            type="email"
            name="email"
            value={formValues.email}
            onChange={handleChange}
            className={`w-full border ${
              errors.email ? "border-red-500" : "border-gray-300"
            } rounded-lg px-5 py-3 text-base focus:ring-2 focus:ring-blue-500 focus:outline-none`}
            placeholder="Enter your email"
          />
          {errors.email && (
            <p className="text-sm text-red-500 mt-1">{errors.email}</p>
          )}
        </div>

        {/* Resume Upload */}
        <div>
          <label className="block text-gray-700 mb-2 text-sm font-semibold">
            Upload Resume (PDF, DOC, DOCX)
          </label>
          <div className="flex items-center gap-x-4">
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              name="resumeFile"
              onChange={handleChange}
              className={`block w-full text-sm text-gray-700
              file:mr-4 file:py-2 file:px-5
              file:rounded-lg file:border-0
              file:text-sm file:font-semibold
              file:bg-blue-100 file:text-blue-800
              hover:file:bg-blue-200 ${
                errors.resumeFile ? "border border-red-500" : ""
              }`}
            />
          </div>
          {formValues.resumeFile && (
            <p className="text-sm text-green-600 mt-2">
              Selected file: {formValues.resumeFile.name}
            </p>
          )}
          {errors.resumeFile && (
            <p className="text-sm text-red-500 mt-1">{errors.resumeFile}</p>
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 rounded-xl font-semibold text-lg transition-all duration-300 hover:scale-[1.02]"
        >
          Submit Application →
        </button>
      </form>

      <Toaster position="top-center" toastOptions={{ duration: 5000 }} />
    </div>
  );
};

export default CareersDetailsForm;
